/** Same-origin API path; works for every hostname that serves the SPA and API together. */
export const getApiBaseUrl = (): string => "/api";
